//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue';
import SliderPrice from "~/components/catalog/SliderPrice.vue"

export default Vue.extend({

  props: {
    filters: {
      type: Array,
      default() {
        return [];
      }
    },
    selectedFilters: {
      type: Object,
      default() {
        return {};
      }
    },
    category: {
      type: Object,
      default() {
        return {};
      }
    },
    loading: {
      type: Boolean,
      default: false
    },

    filterPrices: {
      type: Object,
      default() {
        return {};
      }
    },
  },

  data: function () {
    return {

      activeFilterSlug: "",

      isOpenFilter: false
    };
  },

  components: {
    SliderPrice,
    FilterRangeFrameSize: () => import("~/components/filters/FilterRangeFrameSize.vue")
  },

  computed: {

    filterVariants: function () {
      if (!this.activeFilterSlug) {
        return []
      }

      return this.filters.find((t) => t.slug === this.activeFilterSlug)?.variants || []
    },

    buttonFilterLabel: function () {
      return Boolean(this.isOpenFilter) ? "Скрыть фильтры" : "Показать фильтры"
    },

    sexVariant: function () {
      let items = [
        {slug: `/catalog/${this.category.slug}`, label: "Все"}
      ];

      let variants = [];
      let sexVariants = this.filters.find((t) => t.name === "Пол") || null;
      if (sexVariants) {
        variants = (sexVariants?.variants || []).map((item) => {
          return {
            ...item,
            slug: `/catalog/${this.category.slug}/f/pol=${item.slug}`,
            variantSlug: sexVariants?.slug,
            itemSlug: item.slug
          }
        })
      }

      return [...items, ...variants]
    },

    sexAllActive() {
      return !Boolean(this.$route.path.indexOf('pol=') > -1)
    },

    selected() {
      const filtersInit = [...this.filters];
      const selectedFilters = {...this.selectedFilters};
      const filters = [];

      Object.keys(selectedFilters).map((filterKey) => {
        const filterItem = filtersInit.find(t => t.slug === filterKey);
        const selected = selectedFilters[filterKey];


        if (!!filterItem) {
          Object.keys(selected).map((variantKey) => {
            const variant = filterItem.variants.find(t => String(t.slug) === String(variantKey));

            if (variant && filterKey !== 'pol') {
              filters.push({
                slug: filterKey,
                variant
              });
            }
          });
        }
      });

      return filters;
    },

    labelFilterPrice: function () {
      let priceFrom = +(Object.keys(this.selectedFilters?.priceFrom || {})?.[0] || null);
      let priceTo = +(Object.keys(this.selectedFilters?.priceTo || {})?.[0] || null);

      if (!priceFrom && !priceTo) {
        return ''
      }

      return `Цена: ${this.$numberFormat(priceFrom)} ₽ — ${this.$numberFormat(priceTo)} ₽`
    },

    isSelectedFilterNew: function () {
      return Boolean(this.selectedFilters?.['new'])
    },


    filtersDefault: function () {
      return [...(this.filters || [])]
        .filter((t) => {
          return Boolean(t.filterTemplate !== 'range_frame_size')
        })
    },

    filtersRangeFrameSize: function () {
      return [...(this.filters || [])]
        .filter((t) => {
          return Boolean(t.filterTemplate === 'range_frame_size')
        })
    },
    selectedRangeFrameSize: function () {
      const filtersInit = [...this.filtersDefault];
      const selectedFilters = {...this.selectedFilters};
      const filters = [];

      Object.keys(selectedFilters).map((filterKey) => {
        const selectedFilter = this.filtersRangeFrameSize.find((t) => t.slug === filterKey);
        const selected = selectedFilters[filterKey];
        if (selectedFilter) {
          const [startValue, endValue] = (Object.keys(selected)?.[0] || '').split(":");
          filters.push({
            slug: filterKey,
            variant: {
              label: `${selectedFilter.name}: от ${startValue} до ${endValue}`
            },
            type: 'rangeFrameSize'
          });
        }
      });

      return filters;
    },
    isSelectedRangeFrameSize: function () {
      return Boolean(this.filtersRangeFrameSize.find((t) => this.selectedFilters[t.slug]));
    },

  },

  methods: {

    // Определение активности фильтра
    isSelected(variant, filter) {

      if (!this.selectedFilters[filter]) {
        return false;
      }

      return Boolean(this.selectedFilters[filter][variant]);
    },

    // Опеределение заблокирован ли фильтр
    isDisabledFilterVariant(filter, variant) {
      return !(this.filters.find((t) => t.slug === filter)?.available || []).includes(variant);
    },

    changePrice: function (prices) {
      this.$emit('onChangeFilterVariantPrice', [
        {filterSlug: 'priceFrom', variantSlug: prices[0]},
        {filterSlug: 'priceTo', variantSlug: prices[1]},
      ]);
    },
    getSelectedPrice: function () {
      let priceFrom = +(Object.keys(this.selectedFilters?.priceFrom || {})?.[0] || -1);
      let priceTo = +(Object.keys(this.selectedFilters?.priceTo || {})?.[0] || -1);

      return [priceFrom, priceTo]
    },
    removeFilterPrice: function () {
      this.$emit('onRemoveFilterVariantPrice');
    },

    changeFilterSlug: function (filterSlug, value) {
      let selectedFilters = {...this.selectedFilters};
      if (!value) {
        delete selectedFilters[filterSlug]
      } else {
        selectedFilters[filterSlug] = value;
      }
      this.$emit('searchProducts', selectedFilters);
    },
  }

});
